import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=b1f7a3aa&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f7a3aa')) {
      api.createRecord('b1f7a3aa', component.options)
    } else {
      api.reload('b1f7a3aa', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=b1f7a3aa&", function () {
      api.rerender('b1f7a3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24dGlewkPm8C3/JS/comp/ErrorMessage.vue"
export default component.exports